export default __webpack_public_path__ + "static/media/area-35.339be569.jpg";